import React, { Component } from 'react';
import Header from '../../components/Header';
import classNames from 'classnames';
import StickyHeader from '../../components/StickyHeader/StickyHeader';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import i18n from 'i18n/i18n';
import _ from 'lodash';
import CenteredContent from 'components/CenteredContent/CenteredContent';
import { TemplatesIcon, DocumentsIcon, AssetsIcon } from '../../theme/icons';
import { writeCompanySettings } from 'redux/modules/companies';
import {
	withStyles,
	Typography,
	Grid,
	Checkbox,
	FormGroup,
	Switch,
	IconButton,
	Tooltip
} from '@material-ui/core';
import { Info } from 'theme/icons';

const localize = i18n.loc.localize;

const styles = theme => {
	return {
		header: {
			paddingBottom: 20
		},
		sectionHeading: {
			marginTop: 20,
			marginBottom: 12,
			paddingLeft: 8,
			fontSize: 18,
			lineHeight: 1.5,
			fontWeight: 'bold'
		},
		sectionHeadingEditor: {
			paddingBottom: 5
		},
		showInHomeScreen: {
			marginTop: 10,
			marginBottom: 10,
			fontSize: 14,
			lineHeight: 1.5,
			color: '#2E3F4F',
			opacity: 1
		},
		detailsContainer: {
			marginTop: theme.spacing.unit * 2
		},
		detailsContainerEditor: {
			borderTop: '1px solid #aabfd1',
			paddingTop: 6
		},
		row: {
			marginBottom: 5,
			'&.hover': {
				background: '#e0f5fe'
			}
		},
		firstRow: {
			'&.hover': {
				background: '#e0f5fe'
			}
		},
		lastRow: {
			'& p': {
				position: 'relative',
				top: 7
			}
		},
		labelContainer: {
			'& p': {
				fontSize: 14,
				lineHeight: 1.5,
				paddingTop: 10,
				color: '#2E3F4F',
				opacity: 1
			}
		},
		checkboxLabel: {
			width: 408,
		},
		switchLabel: {
			width: 408,
			'& p': {
				paddingTop: 5
			},
		},
		hasIcon: {
			padding: '0 0 0 25px',
			'& p': {
				display: 'inline-block'
			}
		},
		hasInfoIcon: {
			padding: '0 0 0 8px',
			'& p': {
				display: 'inline-block'
			}
		},
		fieldsetLabel: {
			'& p': {
				fontWeight: 600,
				paddingLeft: 10,
				paddingBottom: 12
			}			
		},
		/* checkbox */
		columnCheckbox: {
		},
		checkbox: {
			padding: '6px 16px 6px 0',
			marginLeft: -3
		},
		checkboxUnchecked: {
			color: '#2E3F4F'
		},
		checkboxUncheckedHover: {
			color: '#2888C3'
		},
		checkboxChecked: {
			root: {
				'&$checked': {
					color: '#2FA5E7'
				}
			}
		},
		checkboxCheckedHover: {
			color: '#2888C3 !important'
		},		
		icon: {
			display: 'inline-block',
			position: 'relative',
			top: '7px',
			marginRight: '10px',
			color: '#2E3F4F'
		},
		/* switch */
		columnSwitch: {
		},
		infoIcon: {
			width: 12,
			height: 12,
			position: 'relative',
			top: 16,
			color: '#6F99BD',
			border: '1px solid #6F99BD',
			padding: 0,
			marginLeft: 6
		},
		/* switch custom style */
		SwitchBase: {
			height: 40,
			'&$SwitchChecked': {
				color: theme.palette.common.white,
				'& + $SwitchBar': {
					backgroundColor: '#2FA5E7',
				}
			},
		},
		SwitchChecked: {
			transform: 'translateX(13px)',
			'& + $SwitchBar': {
				opacity: 1,
				border: 'none',
			},
		},
		SwitchBar: {
			borderRadius: 6,
			width: 16,
			height: 8,
			marginTop: -4,
			marginLeft: -9,
			border: 'solid 1px',
			borderColor: '#6F99BD',
			backgroundColor: '#6F99BD',
			opacity: 1,
			transition: theme.transitions.create(['background-color', 'border']),
		},
		SwitchIcon: {
			width: 10,
			height: 10,
			border: '1px solid #6F99BD',
		},
		SwitchIconChecked: {
			boxShadow: theme.shadows[1],
			border: '1px solid #2FA5E7',
		},
		/* switch hover style */
		SwitchBaseHovered: {
			height: 40,
			'&$SwitchCheckedHovered': {
				color: theme.palette.common.white,
				'& + $SwitchBarHovered': {
					backgroundColor: '#2888C3',
				}
			},
		},
		SwitchCheckedHovered: {
			transform: 'translateX(13px)',
			'& + $SwitchBarHovered': {
				opacity: 1,
				border: 'none',
			},
		},
		SwitchBarHovered: {
			borderRadius: 6,
			width: 16,
			height: 8,
			marginTop: -4,
			marginLeft: -9,
			border: 'solid 1px',
			borderColor: '#2888C3',
			backgroundColor: '#2888C3',
			opacity: 1,
			transition: theme.transitions.create(['background-color', 'border']),
		},
		SwitchIconHovered: {
			width: 10,
			height: 10,
			border: '1px solid #2888C3',
		},
		SwitchIconCheckedHovered: {
			boxShadow: theme.shadows[1],
			border: '1px solid #2888C3',
		},
		/* switch disabled style */
		SwitchBaseDisabled: {
			height: 40,
			'&$SwitchCheckedDisabled': {
				color: theme.palette.common.white,
				'& + $SwitchBarDisabled': {
					backgroundColor: '#bdbdbd',
				}
			},
		},
		SwitchCheckedDisabled: {
			transform: 'translateX(13px)',
			'& + $SwitchBarDisabled': {
				opacity: 1,
				border: 'none',
			},
		},
		SwitchBarDisabled: {
			borderRadius: 6,
			width: 16,
			height: 8,
			marginTop: -4,
			marginLeft: -9,
			border: 'solid 1px',
			borderColor: '#bdbdbd',
			backgroundColor: '#bdbdbd',
			opacity: 1,
			transition: theme.transitions.create(['background-color', 'border']),
		},
		SwitchIconDisabled: {
			width: 10,
			height: 10,
			border: '1px solid #bdbdbd',
		},
		SwitchIconCheckedDisabled: {
			boxShadow: theme.shadows[1],
			border: '1px solid #bdbdbd',
		},
		/* tooltip */
		arrow: {
			position: 'absolute',
			fontSize: 6,
			width: '3em',
			height: '1em',
			bottom: 0,
			left: '50%',
			transform: 'translateX(-50%)',
			marginBottom: '-0.95em',
			'&::before': {
				content: '""',
				margin: 'auto',
				display: 'block',
				width: 0,
				height: 0,
				borderStyle: 'solid',
				borderWidth: '1em 1em 0 1em',
				borderColor: `${theme.palette.common.black} transparent transparent transparent`,
			},
		},
		infoTooltip: {
			padding: 7,
			backgroundColor: theme.palette.common.black,
		},
		infoTooltipText: {
			color: theme.palette.common.white,
			opacity: 1
		}		
	};
};

@withStyles(styles)
class Customize extends Component {

	constructor(props) {
		super(props);
		this.state = {
			teamDocumentsChecked: _.get(this.props.company, 'settings.teamDocumentsEnabled', true),
			teamDocumentsHovered: false,
			teamTemplatesPlaybookFoldersAdminOnlyChecked:
				_.get(this.props.company, 'settings.teamTemplatesPlaybookFoldersAdminOnlyEnabled', false),
			teamTemplatesPlaybookFoldersAdminOnlyHovered: false,
			xaraTemplatesChecked: _.get(this.props.company, 'settings.xaraTemplatesEnabled', true),
			xaraTemplatesHovered: false,
			xaraTemplatesAdminOnlyChecked: _.get(this.props.company, 'settings.xaraTemplatesAdminOnlyEnabled', false),
			xaraTemplatesAdminOnlyHovered: false,
			autoAddAssetsChecked: _.get(this.props.company, 'settings.autoAddAssetsEnabled', true),
			autoAddAssetsHovered: false,
			onlyAdminsCanPublishTeamDocsChecked: _.get(this.props.company, 'settings.onlyAdminsCanPublishTeamDocsEnabled', false),
			onlyAdminsCanPublishTeamDocsHovered: false,
			onlyAdminsCanImportDocsChecked: _.get(this.props.company, 'settings.onlyAdminsCanImportDocsEnabled', false),
			onlyAdminsCanImportDocsHovered: false,
			pendingKey: null,
			pendingValue: null,
			successKey: null
		};
	}

	handleUpdate(nextProps) {
		if (nextProps.company.companySettingsUpdateSuccess === true) {
			this.setState({
				successKey: this.state.pendingKey,
				pendingKey: null,
				pendingValue: null
			});


		} else if (nextProps.company.companySettingsUpdateSuccess === false) {
			this.setState({
				[`${this.state.pendingKey}Checked`]: !this.state.pendingValue,
				[`${this.state.pendingKey}Hovered`]: false,
				pendingKey: null,
				pendingValue: null
			});
		}
	}
	
	componentWillReceiveProps(nextProps) {
		if (this.props.company.companySettingsUpdateSuccess !== nextProps.company.companySettingsUpdateSuccess) {
			this.handleUpdate(nextProps);
		}
	}

	handleChange(event, key) {
		this.setState({
			[`${key}Checked`]: event.target.checked,
			pendingKey: key,
			pendingValue: event.target.checked
		});
		
		this.props.writeCompanySettings({[`${key}Enabled`]: event.target.checked});
	}

	rowMouseEnter(event) {
		event.currentTarget.classList.add('hover');
	}
	
	rowMouseLeave(event) {
		event.currentTarget.classList.remove('hover');
	}

	formElementMouseEnter(key) {
		this.setState({
			[`${key}Hovered`]: true
		});		
	}

	formElementMouseLeave(key) {
		this.setState({
			[`${key}Hovered`]: false
		});		
	}

	getCheckboxClassName(isChecked, isHovered) {
		const { classes } = this.props;
		if (isChecked) {
			return `${classes.checkbox} ${isHovered ? classes.checkboxCheckedHover : classes.checkboxChecked}`;
		} else {
			return `${classes.checkbox} ${isHovered ? classes.checkboxUncheckedHover : classes.checkboxUnchecked}`;
		}
	}

	renderCheckbox(key, isDisabled, isChecked, className) {
		const { classes } = this.props;

		if (isDisabled) {
			return (
				<Checkbox
					disabled
					checked={isChecked}
					data-tid={`customize-company-settings-${key}`}
					id={`customize-company-settings-${key}`}
					className={classes.checkbox}
					color='primary'
				/>
			);
		} else {
			return (
				<Checkbox
					checked={isChecked}
					data-tid={`customize-company-settings-${key}`}
					id={`customize-company-settings-${key}`}
					onChange={event => this.handleChange(event, key)}
					className={className}
					onMouseEnter={() => this.formElementMouseEnter(key)}
					onMouseLeave={() => this.formElementMouseLeave(key)}
					color="primary"
				/>
			);
		}
	}

	renderSwitch(key, isDisabled, isChecked, isHovered) {
		const { classes } = this.props;

		if (isDisabled) {
			return (
				<Switch
					disabled
					checked
					classes={{
						switchBase: classes.SwitchBaseDisabled,
						bar: classes.SwitchBarDisabled,
						icon: classes.SwitchIconDisabled,
						iconChecked: classes.SwitchIconCheckedDisabled,
						checked: classes.SwitchCheckedDisabled,
					}}
					data-tid={`customize-company-settings-${key}`}
					id={`customize-company-settings-${key}`}
					color='primary'
				/>
			);
		} else {
			return (
				<Switch
					checked={isChecked}
					data-tid={`customize-company-settings-${key}`}
					id={`customize-company-settings-${key}`}
					onChange={event => this.handleChange(event, key)}
					classes={{
						switchBase: isHovered ? classes.SwitchBaseHovered : classes.SwitchBase,
						bar: isHovered ? classes.SwitchBarHovered : classes.SwitchBar,
						icon: isHovered ? classes.SwitchIconHovered : classes.SwitchIcon,
						iconChecked: isHovered ? classes.SwitchIconCheckedHovered : classes.SwitchIconChecked,
						checked: isHovered ? classes.SwitchCheckedHovered : classes.SwitchChecked
					}}
					onMouseEnter={() => this.formElementMouseEnter(key)}
					onMouseLeave={() => this.formElementMouseLeave(key)}
					color="primary"
				/>
			);
		}
	}

	render() {
		const { classes } = this.props;

		const teamDocumentsChecked = this.state.teamDocumentsChecked;
		const teamDocumentsHovered = this.state.teamDocumentsHovered;

		const teamTemplatesPlaybookFoldersAdminOnlyChecked = this.state.teamTemplatesPlaybookFoldersAdminOnlyChecked;
		const teamTemplatesPlaybookFoldersAdminOnlyHovered = this.state.teamTemplatesPlaybookFoldersAdminOnlyHovered;
		const teamTemplatesPlaybookFoldersAdminOnlyClassName =
			this.getCheckboxClassName(teamTemplatesPlaybookFoldersAdminOnlyChecked, teamTemplatesPlaybookFoldersAdminOnlyHovered);

		const xaraTemplatesChecked = this.state.xaraTemplatesChecked;
		const xaraTemplatesHovered = this.state.xaraTemplatesHovered;

		const xaraTemplatesAdminOnlyChecked = this.state.xaraTemplatesAdminOnlyChecked;
		const xaraTemplatesAdminOnlyHovered = this.state.xaraTemplatesAdminOnlyHovered;
		const xaraTemplatesAdminOnlyClassName = this.getCheckboxClassName(xaraTemplatesAdminOnlyChecked,
			xaraTemplatesAdminOnlyHovered);

		const autoAddAssetsChecked = this.state.autoAddAssetsChecked;
		const autoAddAssetsHovered = this.state.autoAddAssetsHovered;
		const onlyAdminsCanPublishTeamDocsChecked = this.state.onlyAdminsCanPublishTeamDocsChecked;
		const onlyAdminsCanPublishTeamDocsHovered = this.state.onlyAdminsCanPublishTeamDocsHovered;
		const onlyAdminsCanImportDocsChecked = this.state.onlyAdminsCanImportDocsChecked;
		const onlyAdminsCanImportDocsHovered = this.state.onlyAdminsCanImportDocsHovered;

		return (<CenteredContent>
			<StickyHeader>
				<Header className={classes.header}>{localize('customize-header')}</Header>
			</StickyHeader>
			<Grid container className={classes.detailsContainer}>
				<Grid container direction="column">
					<Typography className={classes.sectionHeading} variant="body2">
						{localize('customize-home-screen')}
					</Typography>
				</Grid>

				<Grid container direction="column">
					<Grid
						container
						direction="row"
						className={classNames(classes.firstRow, classes.lastRow)}
						onMouseEnter={this.rowMouseEnter}
						onMouseLeave={this.rowMouseLeave}>
						<Grid
							item
							container
							className={classNames(classes.labelContainer, classes.switchLabel, classes.hasInfoIcon)}>

							<Typography variant="body2">
								{localize('customize-admins-only-import-docs')}
							</Typography>
						</Grid>
						<Grid item className={classes.columnSwitch}>
							{this.renderSwitch('onlyAdminsCanImportDocs', false, onlyAdminsCanImportDocsChecked,
								onlyAdminsCanImportDocsHovered)}
						</Grid>
					</Grid>
				</Grid>

				<Grid container direction="column">
					<FormGroup>
						<Grid container direction="row">
							<Grid
								item
								className={classNames(classes.labelContainer, classes.checkboxLabel, classes.fieldsetLabel)}>
								<Typography variant="body2">
									{localize('customize-files', this.props.company.displayName)}
								</Typography>
							</Grid>
						</Grid>
						<Grid
							container
							direction="row"
							className={classes.row}
							onMouseEnter={this.rowMouseEnter}
							onMouseLeave={this.rowMouseLeave}>
							<Grid item className={classNames(classes.labelContainer, classes.checkboxLabel, classes.hasIcon)}>
								<DocumentsIcon className={classes.icon} />
								<Typography variant="body2">{localize('customize-documents')}</Typography>
							</Grid>
							<Grid item>
								{this.renderSwitch('teamDocuments', false, teamDocumentsChecked, teamDocumentsHovered)}
							</Grid>
							<Grid item>
								<Typography className={classes.showInHomeScreen} variant="body2">
									{localize('customize-show-in-home-screen')}
								</Typography>
							</Grid>
						</Grid>
						<Grid
							container
							direction="row"
							className={classes.row}
							onMouseEnter={this.rowMouseEnter}
							onMouseLeave={this.rowMouseLeave}>
							<Grid item className={classNames(classes.labelContainer, classes.checkboxLabel, classes.hasIcon)}>
								<TemplatesIcon className={classes.icon} />
								<Typography variant="body2">{localize('customize-templates')}</Typography>
							</Grid>
							<Grid item>
								{this.renderSwitch('teamTemplates', /* isDisabled */ true)}
							</Grid>
							<Grid item>
								<Grid container direction="column">
									<Typography className={classes.showInHomeScreen} variant="body2">
										{localize('customize-show-in-home-screen')}
									</Typography>
								</Grid>
								{ /* Team Templates always turned on, switch disabled */ }
								<Grid item>
									<Grid container direction="row">
										{this.renderCheckbox('teamTemplatesPlaybookFoldersAdminOnly', false,
											teamTemplatesPlaybookFoldersAdminOnlyChecked,
											teamTemplatesPlaybookFoldersAdminOnlyClassName)}
										<Typography className={classes.showInHomeScreen} variant="body2">
											{localize('customize-show-playbook-folders-to-admins-only')}
										</Typography>
									</Grid>
								</Grid>
							</Grid>
						</Grid>
						<Grid
							container
							direction="row"
							className={classes.row}
							onMouseEnter={this.rowMouseEnter}
							onMouseLeave={this.rowMouseLeave}>
							<Grid item className={classNames(classes.labelContainer, classes.checkboxLabel, classes.hasIcon)}>
								<AssetsIcon className={classes.icon} />
								<Typography variant="body2">{localize('customize-assets')}</Typography>
							</Grid>
							<Grid item>
								{this.renderSwitch('teamAssets', true)}
							</Grid>
							<Grid item>
								<Typography className={classes.showInHomeScreen} variant="body2">
									{localize('customize-show-in-home-screen')}
								</Typography>
							</Grid>
						</Grid>
					</FormGroup>
				</Grid>

				<Grid container direction="column">
					<Grid
						container
						direction="row"
						className={classes.row}
						onMouseEnter={this.rowMouseEnter}
						onMouseLeave={this.rowMouseLeave}>
						<Grid item className={classNames(classes.labelContainer, classes.checkboxLabel, classes.fieldsetLabel)}>
							<Typography variant="body2">{localize('customize-xara-templates')}</Typography>
						</Grid>
						<Grid item>
							{this.renderSwitch('xaraTemplates', false, xaraTemplatesChecked, xaraTemplatesHovered)}
						</Grid>
						<Grid item>
							<Grid container direction="column">
								<Grid item>
									<Typography className={classes.showInHomeScreen} variant="body2">
										{localize('customize-show-in-home-screen')}
									</Typography>
								</Grid>
								{xaraTemplatesChecked && (
									<Grid item>
										<Grid container direction="row">
											{this.renderCheckbox('xaraTemplatesAdminOnly', false,
												xaraTemplatesAdminOnlyChecked, xaraTemplatesAdminOnlyClassName)}
											<Typography className={classes.showInHomeScreen} variant="body2">
												{localize('customize-show-to-admins-only')}
											</Typography>
										</Grid>
									</Grid>
								)}
							</Grid>
						</Grid>
					</Grid>
				</Grid>
			</Grid>
			<Grid container className={classNames(classes.detailsContainer, classes.detailsContainerEditor)}>
				<Grid container direction="column">
					<Typography className={classNames(classes.sectionHeading, classes.sectionHeadingEditor)} variant="body2">
						{localize('customize-editor')}
					</Typography>
				</Grid>

				<Grid container direction="column">
					<Grid
						container
						direction="row"
						className={classNames(classes.row, classes.lastRow)}
						onMouseEnter={this.rowMouseEnter}
						onMouseLeave={this.rowMouseLeave}>
						<Grid
							item
							container
							className={classNames(classes.labelContainer, classes.switchLabel, classes.hasInfoIcon)}>

							<Typography variant="body2">
								{localize('customize-automatically-save-images')}
							</Typography>
							<Tooltip
								placement="top"
								title={
									<React.Fragment>
										<Typography variant='body2' className={classNames(classes.infoTooltipText)}>
											{localize('customize-automatically-save-images-info')}
										</Typography>		
										<span className={classes.arrow} />
									</React.Fragment>
								}
								classes={{
									tooltip: classes.infoTooltip
								}}
							>
								<IconButton
									className={classes.infoIcon}
									color='primary'
									component='span'
									disableRipple>
									<Info />
								</IconButton>
							</Tooltip>
						</Grid>
						<Grid item className={classes.columnSwitch}>
							{this.renderSwitch('autoAddAssets', false, autoAddAssetsChecked, autoAddAssetsHovered)}
						</Grid>
					</Grid>
				</Grid>

				<Grid container direction="column">
					<Grid
						container
						direction="row"
						className={classNames(classes.row, classes.lastRow)}
						onMouseEnter={this.rowMouseEnter}
						onMouseLeave={this.rowMouseLeave}>
						<Grid
							item
							container
							className={classNames(classes.labelContainer, classes.switchLabel, classes.hasInfoIcon)}>

							<Typography variant="body2">
								{localize('customize-admins-only-publish-team-docs')}
							</Typography>
						</Grid>
						<Grid item className={classes.columnSwitch}>
							{this.renderSwitch('onlyAdminsCanPublishTeamDocs', false, onlyAdminsCanPublishTeamDocsChecked,
								onlyAdminsCanPublishTeamDocsHovered)}
						</Grid>
					</Grid>
				</Grid>
			</Grid>
		</CenteredContent>);
	}
}

const mapStateToProps = state => ({
	company: state.companies.rawDataById[state.companies.selectedId]
});

const mapDispatchToProps = dispatch => bindActionCreators({
	writeCompanySettings
}, dispatch);

Customize.propTypes = {
	classes: PropTypes.object,
	company: PropTypes.object,
	writeCompanySettings: PropTypes.func
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(Customize);


// WEBPACK FOOTER //
// ./src/containers/Customize/Customize.js